import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { LocationResponseInterface, StoreViewInterface } from "../models/store";

@Component({
    selector: 'gea-shop-opening-hours',
    template: `
    <div *ngIf="location" class="opening-hours mt-3">
      <!--
      <div *ngIf="hasCurrentlyOpened" class="text-bg-success">Zur Zeit geöffnet!</div>
      <div *ngIf="hasSoonOpened" class="text-bg-danger">Zur Zeit nicht geöffnet!</div>
      -->
<!--      <div class="opening-hours-header">Öffnungszeiten</div>-->

      <div class="isclosed" *ngIf="willBeClosed">
        <p *ngIf="closedForever; else tempclosed">
          Diese Filiale ist ab {{ closedFrom }} dauerhaft geschlossen.
        </p>
        <ng-template #tempclosed>
          <p *ngIf="closedForOneDay">Diese Filiale ist am {{ closedFrom }} geschlossen.</p>
          <p *ngIf="!closedForOneDay">Diese Filiale ist ab {{ closedFrom }} geschlossen und öffnet wieder am {{ openAgainAt }}.</p>
        </ng-template>
      </div>

      <div class="isclosed" *ngIf="currentlyClosed; else isopen">
        <p *ngIf="closedForever; else tempclosed">
          Diese Filiale ist dauerhaft geschlossen.
        </p>
        <ng-template #tempclosed>
          <p>Diese Filiale ist vorübergehend geschlossen und öffnet wieder am {{ openAgainAt }}.</p>
        </ng-template>
      </div>

      <ng-template #isopen>
        <div class="opening-hours-list">
          <ng-container *ngIf="location.openingHours">
            <span class="prerendered">{{ location.openingHours }}</span>
          </ng-container>
          <ng-container *ngIf="! location.openingHours">
            <ng-container *ngFor="let hours of location.hours; let i=index">
              <span *ngIf="hours && (hours[0] || hours[1])">
                <span class="ln workday-name">{{ weekdays[i][1]}}</span>
                <span class="ln workday-am" *ngIf="hours">{{ hours }}</span>
              </span>
            </ng-container>
          </ng-container>
        </div>
      </ng-template>
<!--      <div class="opening-hours-header">Kontakt</div>-->
<!--      <div class="opening-hours-list">-->
<!--        <div *ngIf="location.email"><a href="mailto:{{ location.email }}">{{ location.email }}</a></div>-->
<!--        <div *ngIf="location.address.telephone"><a href="tel:{{ location.address.telephone }}">{{ location.address.telephone }}</a></div>-->
<!--        <div *ngIf="location.facebook">Facebook: <a target="_blank" href="{{ location.facebook }}">{{ location.facebook }}</a></div>-->
<!--        <div *ngIf="location.instagram">Instagram: <a target="_blank" href="{{ location.instagram }}">{{ location.instagram }}</a></div>-->
<!--        <div *ngIf="location.googleMaps">Google Maps: <a target="_blank" href="{{ location.googleMaps }}">{{ location.googleMaps }}</a></div>-->
<!--      </div>-->
    </div>
  `,
    standalone: false
})
export class OpeningHoursComponent implements OnChanges {
  @Input() location?: StoreViewInterface | LocationResponseInterface
  @Input() now: Date
  weekdays: [string[], string[], string[], string[], string[], string[], string[]] =
    [
      ['Mo.', 'Montag'], ['Di.', 'Dienstag'], ['Mi.', 'Mittwoch'], ['Do.', 'Donnerstag'],
      ['Fr.', 'Freitag'], ['Sa.', 'Samstag'], ['So.', 'Sonntag']
    ]
  dayOfWeekIndex: number
  hasCurrentlyOpened: boolean = false

  constructor(
  ) {
    this.now = new Date()
    this.dayOfWeekIndex = this.now.getDay() - 1
  }

  public get openAgainAt() {
    if (this.location?.closedUntil) {
      let closedUntilDate = new Date(this.location?.closedUntil)
      let openAtDate = new Date(closedUntilDate.getTime() + 86400000)
      return openAtDate.toLocaleDateString()
    }

    throw Error('No closed until date set!')
  }

  public get closedFrom() {
    if (this.location?.closedFrom) {
      let closedFromDate = new Date(this.location?.closedFrom)
      return closedFromDate.toLocaleDateString()
    }

    throw Error('No closed from date set!')
  }

  public get closedForever() {
    if (this.location?.closedFrom && this.location?.closedUntil) {
      return false
    }
    return true
  }

  public get closedForOneDay() {
    if (!this.location?.closedFrom || !this.location?.closedUntil) {
      return false
    }

    const dateClosedUntil = this.getDate(this.location.closedUntil)
    const dateClosedFrom = this.getDate(this.location.closedFrom)
    return  this.isSameDay(dateClosedFrom, dateClosedUntil)
  }

  public get currentlyClosed() {
    let closedFromDate: Date | null = null
    let closedToDate: Date | null = null
    let today: Date = this.getDate()

    if (this.location?.closedFrom) {
      closedFromDate = this.getDate(this.location.closedFrom)
    }
    if (this.location?.closedUntil) {
      closedToDate = this.getDate(this.location.closedUntil)
    }

    if (closedFromDate && closedToDate) {
       // temporary closed
      if (closedFromDate <= today && today <= closedToDate) return true
    } else if (closedFromDate && !closedToDate) {
      // forever closed
      if (closedFromDate <= today) return true
    }

    return false
  }

  public get willBeClosed() {
    if (this.currentlyClosed) return false

    let closedFromDate: Date | null = null
    let today: Date = this.getDate()

    if (this.location?.closedFrom) {
      closedFromDate = this.getDate(this.location.closedFrom)
      return (today < closedFromDate)
    }

    return false
  }

  private getDate(date? : string) {
    const d = date ? new Date(date) : new Date()
    d.setHours(0, 0, 0, 0) 
    return d
  }

  private isSameDay(date1 : Date, date2 : Date) {
    return date1.getFullYear() == date2.getFullYear() &&
           date1.getMonth() == date2.getMonth() &&
           date1.getDate() == date2.getDate()
  }

  private hasOpened(intervalString: string | null, now: Date): boolean {
    if (! intervalString) {
      return false
    }

    let hasOpened = false
    let time = parseInt(now.getHours() + now.getMinutes().toString().padStart(2, '0'))

    const hours = this.location?.hours[this.dayOfWeekIndex]
    if (! hours) return false

    hours.split(',').forEach((interval) => {
      let times = interval.trim().split('-').map((v) => {
        return parseInt(v.replace(':', ''))
      })
      if (times[0] < time && times[1] > time) hasOpened = true
    })

    return hasOpened
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.hasOwnProperty('now')) {
      let now = changes["now"].currentValue
      this.dayOfWeekIndex = this.now.getDay() - 1
      if (this.location?.hours[this.dayOfWeekIndex]?.length) {
        this.hasCurrentlyOpened = this.hasOpened(this.location?.hours[this.dayOfWeekIndex], now)
      }
    }
  }
}
